// @core/api/endpoints/platform/sync_federation_catalog.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SyncFederationCatalogRequest,
  SyncFederationCatalogResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Force federation catalog sync
 * Triggers an immediate catalog synchronization with the specified peer. Normally sync happens on schedule.
 */
export async function SyncFederationCatalog(
  peer_id: string,
  data: SyncFederationCatalogRequest,
  options?: RequestOptions
): Promise<SyncFederationCatalogResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/federation/peers/:peer_id/sync`;
  requestPath = requestPath.replace(':peer_id', encodeURIComponent(peer_id));
  const requestOptions = options;
  return client.post<SyncFederationCatalogResponse>(requestPath, data, requestOptions);
}
